import { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import supabase from '../supabase';
import '../design-system.css';

function Contact() {
    const [form, setForm] = useState({ name: '', email: '', message: '' });
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => { document.title = 'Contact | winston.ie'; }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        if (!form.name || !form.email || !form.message) { setError('Remplis tous les champs.'); return; }

        setLoading(true);
        const { error: insertError } = await supabase.from('contacts').insert({
            name: form.name, email: form.email, message: form.message, created_at: new Date().toISOString(),
        });
        setLoading(false);

        if (insertError) { setError('Une erreur est survenue. Réessaie.'); return; }
        setDone(true);
    };

    if (done) {
        return (
            <div className="w-page">
                <Navbar variant="light" />
                <div className="w-body" style={{ maxWidth: '440px', textAlign: 'center', paddingTop: '80px' }}>
                    <h1 className="w-title">Message envoyé</h1>
                    <p className="w-subtitle">Merci — on te répond dès que possible.</p>
                </div>
                <Footer variant="light" />
            </div>
        );
    }

    return (
        <div className="w-page">
            <Navbar variant="light" />
            <div className="w-body" style={{ maxWidth: '420px' }}>
                <p className="w-eyebrow">winston.ie</p>
                <h1 className="w-title" style={{ marginBottom: '4px' }}>Nous contacter</h1>
                <p className="w-subtitle" style={{ marginBottom: '32px' }}>Une question, une collaboration ? Écris-nous.</p>

                <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    <div className="w-field-group" style={{ marginBottom: 0 }}>
                        <p className="w-field-label">Nom</p>
                        <input value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} className="w-field-input" required />
                    </div>
                    <div className="w-field-group" style={{ marginBottom: 0 }}>
                        <p className="w-field-label">Email</p>
                        <input type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} className="w-field-input" required />
                    </div>
                    <div className="w-field-group" style={{ marginBottom: 0 }}>
                        <p className="w-field-label">Message</p>
                        <textarea value={form.message} onChange={e => setForm(f => ({ ...f, message: e.target.value }))} rows={5} className="w-field-textarea" required />
                    </div>
                    {error && <p style={{ color: '#a3382f', fontSize: '12.5px', margin: 0 }}>{error}</p>}
                    <button
                        type="submit"
                        className="wlink"
                        disabled={loading}
                        style={{ alignSelf: 'flex-start', background: 'none', border: 'none', padding: 0, borderRadius: 0, fontWeight: 300, fontSize: '15px', color: 'var(--w-ink)', opacity: loading ? 0.5 : undefined }}
                    >
                        {loading ? 'Envoi...' : 'Envoyer →'}
                    </button>
                </form>
            </div>
            <Footer variant="light" />
        </div>
    );
}

export default Contact;